module.exports = __webpack_public_path__ + "static/mirabelle-0bbe0606e49fbc17b24ba096b6d89939.svg";